import axios from '@/utils/request'

/**
 * 产业列表
 * @param {pageSize}
 * @param {pageIndex}
 * @param {word}
 */
export const getIndustryList = (params) => axios({
  url: '/industry',
  params
})

/**
 * 产业功能数组
 */
export const getFunList = () => axios({
  url: '/industry/function'
})

/**
 * 产业详情
 */
export const getIndustryDetail = (uuid) => axios({
  url: `/industry/${uuid}`
})

/**
 * 删除产业
 */
export const deleteIndustry = (params) => axios({
  url: `/industry/${params.uuid}`,
  method: 'delete'
})

/**
 * 修改产业
 * @param {同新增产业api}
 */
export const updateIndustry = (data) => axios({
  url: '/industry',
  data,
  method: 'put'
})

/**
 * 新增产业
 * @param { area }
 * @param { city }
 * @param { detailsAddress }
 * @param { province }
 * @param { erpSupplierAppId } erp供应商appid
 * @param { erpSupplierSecret } erp供应商secret
 * @param { erpSupplierType } erp供应商类型：o明源 ,
 * @param { erpSupplierUrl} erp供应商接口地址
 * @param { functionUuidList} 产业功能List
 * @param { indexNum} 排序
 * @param { latitude} 纬度
 * @param { longitude} 经度
 * @param { name} 产业名称
 * @param { parkingSupplierAppId} 停车场供应商appid
 * @param { parkingSupplierPackId} 停车场供应商packid
 * @param { parkingSupplierSecret} 停车场供应商secret
 * @param { parkingSupplierType} 停车场供应商类型：o科拓
 * @param { parkingSupplierUrl} 停车场供应商接口地址
 * @param { visitorSupplierAppId} 访客供应商appid
 * @param { visitorSupplierSecret} 访客供应商secret
 * @param { visitorSupplierType} 访客供应商类型：o旗云；1捷顺
 * @param { visitorSupplierUrl } 访客供应商接口地址
 */
export const addIndustry = (data) => axios({
  url: '/industry',
  data,
  method: 'post'
})

/**
 * 所有产业 下拉选择
 */
export const getIndustrySelectList = () => axios({
  url: '/industry/all'
})

/**
 * 编辑产业功能
 */
export const updateFun = (data) => axios({
  url: '/industry/function',
  method: 'put',
  data
})
